import { Dialog } from "radix-ui"

import type { DialogProps } from "./Dialog"
import styles from "./FullscreenDialog.module.css"

/* Private component. */

type Props = { onEscapeKeyDown: (evt: KeyboardEvent) => void } & Pick<
  DialogProps,
  "open" | "onOpenChange" | "trigger" | "children" | "onAnimationEnd"
>

export function FullscreenDialog(props: Props) {
  const { trigger, children, onAnimationEnd, onEscapeKeyDown, ...otherProps } =
    props

  return (
    <Dialog.Root {...otherProps}>
      {trigger && <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>}

      <Dialog.Portal>
        <Dialog.Content
          className={styles.container}
          onAnimationEnd={onAnimationEnd}
          onEscapeKeyDown={onEscapeKeyDown}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
